import classes from './RemoveButton.module.scss'
import { FiX } from 'react-icons/fi'

export interface Props {
  onClick: () => void
}

const RemoveButton = ({
  onClick
}: Props) =>
  <button
    aria-label='Remove'
    className={classes.RemoveButton}
    onClick={onClick}
    type='button'
  >
    <FiX
      aria-hidden
      className={classes.IconStyle}
      size='16px'
    />
  </button>

export default RemoveButton
